import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Heading from '../common/Heading';

const Contact = () => {
  return (
    <div className='contact' id='contact'>
      <Heading heading='So erreichen Sie uns' subHeading='Anfahrt und Kontakt' />

      <Container>
        <Row>
          <Col xs={12} xl={4}>
            <h3 className='h3'>Parken</h3>
            <p className='p'>
              Hervorragende Parkmöglichkeiten in der Q-Park Tiefgarage des Carré sowie Behindertenparkplatz neben dem
              Büroeingang.
            </p>
            <p className='p'>
              Geben Sie in Ihr Navigationsgerät als Zieladresse für die Tiefgarage Deckerstraße 29, 70372 Stuttgart ein.
            </p>
            <iframe
              src='https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d2628.005119875285!2d9.220048215939324!3d48.80088091270795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e0!4m0!4m5!1s0x4799c51bcbf70911%3A0xa67351edbf6d5229!2sDeckerstra%C3%9Fe%2029%2C%2070372%20Stuttgart!3m2!1d48.8008774!2d9.2222369!5e0!3m2!1sen!2sde!4v1587819840777!5m2!1sen!2sde'
              width='100%'
              height='250'
              frameBorder='0'
              allowFullScreen=''
              aria-hidden='false'
              tabIndex='0'
              title='google-maps'
            />
          </Col>
          <Col xs={12} xl={4}>
            <h3 className='h3'>ÖPNV/Fußweg</h3>
            <p className='p'>
              4-Minuten Fußweg von der S-Bahnstation/Bahnhof “Bad Cannstatt”: Durch den Haupteingang (Nord) den Bahnhof
              verlassen, rechts die Bahnhofstraße entlang bis zum Kreisverkehr und die Straße überqueren.
            </p>
            <p className='p'>
              7-Minuten Fußweg von den U-Bahnstation “Wilhelmsplatz” bzw. “Badstraße” über die Seelbergstraße oder von
              der U-Bahnstation “Daimlerplatz” über die Daimlerstraße.
            </p>
            <p className='p'>
              Dann jeweils über die Treppe das Carré durchqueren und die Mall im 1. Stock auf der Rückseite verlassen.
              Unser Büroeingang befindet sich am Ende des rechten Gebäudeflügels.
            </p>
          </Col>
          <Col xs={12} xl={4}>
            <h3 className='h3'>Schreiben Sie uns</h3>
            <p className='p'>
              Sie können uns jederzeit gerne eine Email schreiben. Wir arbeiten momentan an einem komfortablen
              Kontaktformular, welches Sie dann in Zukunft verwenden können. <br />
              Bis dahin bitten wir Sie uns eine Email mit Ihrem Standard Email-Programm zukommen zu lassen.
            </p>
            <p className='p email'>info@ll-notare.de</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
